import React, { useState } from "react";
import { Drawer } from "antd";
import AnalyzeTool from "./AnalyzeTool";
import { useHistory } from "react-router-dom";

const ViewIcon = ({ content, updated, mid, upd }) => {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const showDrawer = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <>
      <svg
        onClick={(e) => {
          showDrawer(e);
        }}
        className='text-blue-400 w-5 cursor-pointer ml-1 view-svg'
        fill={"none"}
        stroke='currentColor'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z'
        />
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z'
        />
      </svg>
      <Drawer
        onClick={(ev) => ev.stopPropagation()}
        placement='right'
        closable={false}
        onClose={onClose}
        visible={visible}
        width={"26.5%"}
        title={
          <div className='w-full flex px-1 justify-between items-center'>
            <div>
              <p className='m-0 p-0 text-gray-500 text-sm'>Last Updated :</p>
              <p className='m-0 p-0 text-blue-400 font-bold'>{upd}</p>
            </div>
            <p
              onClick={() => history.push(`/dashboard/memo/${mid}`)}
              className='bg-blue-400 text-white font-bold text-center p-3 rounded-md cursor-pointer hover:bg-blue-500 shadow-sm m-0 border-b-4 border-blue-500 flex justify-center items-center'
            >
              View Memo
            </p>
          </div>
        }
      >
        <AnalyzeTool memo={content} updated={updated} isIndex={false} />
      </Drawer>
    </>
  );
};

export default ViewIcon;
